var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { Label } from '../elements/index';
import { useIntl } from 'react-intl';
import { useState } from 'react';
import { TextField, Grid, Button, IconButton, InputAdornment, OutlinedInput } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { updateNeedToChangePassword } from '../../utils/Cookie';
export const ResetPassword = ({ apiMethod, useStyles, hasLabels, showOldPassword }) => {
    const intl = useIntl();
    const [passwordOld, setPasswordOld] = useState('');
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [passwordValidationUppercase, setPasswordValidationUppercase] = useState(false);
    const [passwordValidationLowercase, setPasswordValidationLowercase] = useState(false);
    const [passwordValidationNumbers, setPasswordValidationNumbers] = useState(false);
    const [passwordValidationLength, setPasswordValidationLength] = useState(false);
    const [passwordRepeatError, setPasswordRepeatError] = useState(false);
    const [passwordOldError, setPasswordOldError] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const passwordRegexUppercase = /^(?=.*[A-ZÅÄÖ]).+$/;
    const passwordRegexLowercase = /^(?=.*[a-zåäö]).+$/;
    const passwordRegexNumbers = /^(?=.*[0-9]).+$/;
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const history = useHistory();
    const classes = useStyles();
    const validatePassword = (newPassword) => {
        setPasswordValidationLength(newPassword.length >= 8 && newPassword.length <= 64);
        setPasswordValidationUppercase(passwordRegexUppercase.test(newPassword));
        setPasswordValidationLowercase(passwordRegexLowercase.test(newPassword));
        setPasswordValidationNumbers(passwordRegexNumbers.test(newPassword));
    };
    const onChangePassword = (value) => {
        setPassword(value);
        validatePassword(value);
    };
    const onChangeRepeatPassword = (value) => {
        setRepeatPassword(value);
        setPasswordRepeatError(value !== password && password.length > 0);
    };
    const UpdatePassword = () => __awaiter(void 0, void 0, void 0, function* () {
        validatePassword(password);
        if (passwordOld && password == repeatPassword) {
            yield apiMethod({
                oldPassword: passwordOld,
                newPassword: password
            })
                .then(() => {
                setPassword('');
                setPasswordOld('');
                setRepeatPassword('');
                setPasswordOldError(false);
                setPasswordRepeatError(false);
                setSuccessMessage(intl.formatMessage({ id: 'response.successfullyUpdatePassword' }));
            })
                .catch(err => {
                if (err.response.status === 401) {
                    setPasswordOldError(true);
                }
                else {
                    window.alert(err);
                }
            });
        }
    });
    const UpdatePasswordWithoutOldPassword = () => __awaiter(void 0, void 0, void 0, function* () {
        validatePassword(password);
        if (password === repeatPassword) {
            yield apiMethod({
                newPassword: password
            })
                .then(() => {
                setPassword('');
                setRepeatPassword('');
                setPasswordRepeatError(false);
                updateNeedToChangePassword();
            })
                .catch(err => {
                if (err.response.status === 401) {
                    setPasswordOldError(true);
                }
                else {
                    window.alert(err);
                }
            });
        }
    });
    return (React.createElement(Grid, { container: true, direction: "column", spacing: 3, style: { maxWidth: '100%' } },
        showOldPassword && (React.createElement(Grid, { item: true },
            hasLabels && (React.createElement(Label, { className: classes.label }, intl.formatMessage({ id: 'common.oldPassword' }))),
            React.createElement(TextField, { className: classes.input, value: passwordOld, onChange: e => setPasswordOld(e.target.value), fullWidth: true, error: passwordOldError, helperText: passwordOldError &&
                    intl.formatMessage({ id: 'errormessage.password-old-mismatch' }), type: "password", placeholder: !hasLabels ? intl.formatMessage({ id: 'common.oldPassword' }) : '' }))),
        React.createElement(Grid, { item: true },
            hasLabels && (React.createElement(Label, { className: classes.label }, intl.formatMessage({ id: 'common.pick-password' }))),
            React.createElement(OutlinedInput, { className: classes.inputPassword, id: "standard-adornment-password", type: showPassword ? 'text' : 'password', value: password, onChange: e => onChangePassword(e.target.value), endAdornment: React.createElement(InputAdornment, { position: "end" },
                    React.createElement(IconButton, { "aria-label": "toggle password visibility", onClick: () => setShowPassword(!showPassword), onMouseDown: e => e.preventDefault() }, showPassword ? React.createElement(Visibility, null) : React.createElement(VisibilityOff, null))) })),
        password && (React.createElement("div", { className: classes.passwordValidationsGrid },
            passwordValidationLength ? (React.createElement("div", { className: classes.passwordValidations },
                React.createElement(CheckCircleIcon, { fontSize: 'small', style: { color: "#009B48" } }),
                React.createElement("h4", { style: { fontWeight: 'lighter', color: 'black', marginLeft: '8px' } }, intl.formatMessage({ id: 'password.check.length' })))) : (React.createElement("div", { className: classes.passwordValidations },
                React.createElement(CheckCircleIcon, { fontSize: 'small', color: 'disabled' }),
                React.createElement("h4", { style: { color: '#929292', marginLeft: '8px', fontWeight: 'lighter' } }, intl.formatMessage({ id: 'password.check.length' })))),
            passwordValidationUppercase ? (React.createElement("div", { className: classes.passwordValidations },
                React.createElement(CheckCircleIcon, { fontSize: 'small', style: { color: "#009B48" } }),
                React.createElement("h4", { style: { fontWeight: 'lighter', color: 'black', marginLeft: '8px' } }, intl.formatMessage({ id: 'password.check.uppercase' })))) : (React.createElement("div", { className: classes.passwordValidations },
                React.createElement(CheckCircleIcon, { fontSize: 'small', color: 'disabled' }),
                React.createElement("h4", { style: { fontWeight: 'lighter', color: '#929292', marginLeft: '8px' } }, intl.formatMessage({ id: 'password.check.uppercase' })))),
            passwordValidationLowercase ? (React.createElement("div", { className: classes.passwordValidations },
                React.createElement(CheckCircleIcon, { fontSize: 'small', style: { color: "#009B48" } }),
                React.createElement("h4", { style: { fontWeight: 'lighter', color: 'black', marginLeft: '8px' } }, intl.formatMessage({ id: 'password.check.lowercase' })))) : (React.createElement("div", { className: classes.passwordValidations },
                React.createElement(CheckCircleIcon, { fontSize: 'small', color: 'disabled' }),
                React.createElement("h4", { style: { fontWeight: 'lighter', color: '#929292', marginLeft: '8px' } }, intl.formatMessage({ id: 'password.check.lowercase' })))),
            passwordValidationNumbers ? (React.createElement("div", { className: classes.passwordValidations },
                React.createElement(CheckCircleIcon, { fontSize: 'small', style: { color: "#009B48" } }),
                React.createElement("h4", { style: { fontWeight: 'lighter', color: 'black', marginLeft: '8px' } }, intl.formatMessage({ id: 'password.check.numbers' })))) : (React.createElement("div", { className: classes.passwordValidations },
                React.createElement(CheckCircleIcon, { fontSize: 'small', color: 'disabled' }),
                React.createElement("h4", { style: { fontWeight: 'lighter', color: '#929292', marginLeft: '8px' } }, intl.formatMessage({ id: 'password.check.numbers' })))))),
        React.createElement(Grid, { item: true },
            hasLabels && (React.createElement(Label, { className: classes.label }, intl.formatMessage({ id: 'common.repeat-password' }))),
            React.createElement(OutlinedInput, { className: classes.inputPassword, id: "standard-adornment-password", type: showRepeatPassword ? 'text' : 'password', value: repeatPassword, onChange: e => onChangeRepeatPassword(e.target.value), endAdornment: React.createElement(InputAdornment, { position: "end" },
                    React.createElement(IconButton, { "aria-label": "toggle password visibility", onClick: () => setShowRepeatPassword(!showRepeatPassword), onMouseDown: e => e.preventDefault() }, showRepeatPassword ? React.createElement(Visibility, null) : React.createElement(VisibilityOff, null))) }),
            passwordRepeatError && repeatPassword.length > 0 && (React.createElement("p", { className: classes.passwordRepeatErrorText }, intl.formatMessage({ id: 'errormessage.password-mismatch' })))),
        React.createElement(Grid, { item: true }, showOldPassword ?
            React.createElement(Button, { className: classes.button, disabled: !repeatPassword ||
                    !passwordOld ||
                    !password, variant: "contained", onClick: () => UpdatePassword() }, intl.formatMessage({ id: 'common.save' }))
            :
                React.createElement(Button, { className: classes.button, disabled: repeatPassword !== password ||
                        !passwordValidationLength ||
                        !passwordValidationUppercase ||
                        !passwordValidationLowercase ||
                        !passwordValidationNumbers, variant: "contained", onClick: () => UpdatePasswordWithoutOldPassword() }, intl.formatMessage({ id: 'common.save' }))),
        React.createElement(Grid, { item: true },
            React.createElement("p", null, successMessage))));
};
export default ResetPassword;
